import boxGif from "icons/box/box_red.gif"
import boxImg from "icons/box/box_red.jpg"
import midBoxImg from "icons/box/box_mid.jpg"

export default {
  gif: boxGif,
  img: boxImg,
  emptyState: midBoxImg,
}
